// Shop subscription helpers.
//
// Inventory management is sold as a separate subscription. The sidebar has always
// decided this by reading localStorage["subscription"] and comparing
// customSubscriptionId, but it did so without guarding against the key being absent.

export const getSubscriptionDetails = (): any | null => {
  try {
    const raw = localStorage.getItem("subscription");
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    // a malformed entry must not take a screen down
    return null;
  }
};

// True when the shop has the inventory management subscription.
//
// With it, packs reach a screen slot through Confirm/Activate in the inventory
// module, and sold-out is driven by the Sales screen. The dashboard's own ticket
// entry and sold-out controls are therefore turned off for these shops, so the two
// sides cannot disagree about what is on a slot.
export const hasInventoryManagement = (): boolean => {
  const details = getSubscriptionDetails();
  return !!details && details.customSubscriptionId !== 1;
};
